// extracted by mini-css-extract-plugin
module.exports = {"select":"select__1PjUU","archived":"archived__37MPV"};